export default {
  title: "dark",

  colors: {
    primary: "#00b000",
    secondary: "#f8a200",
    tertiary: "#6B53C6",

    background: {
      primary: "#32323c",
      secondary: "#231f29",
      textInput: "#32323c"
    },
    text: "#FFF",
    tableBorder: "#515151",
    mapFill: "#32323c",
    mapHover: "#231f29",
    mapStroke: "#231f29",
    chart: {
      primary: "#00b000",
      secondary: "#f8a200",
      tertiary: "#000000",
      quaternary: "#cccccc"
    },
    textInputBorder: "#32323c"
  }
};
